import { styled } from '@mui/material';
import React from 'react';
import diagonalLinesRight from '../../assets/patterns/diagonal_lines_right.png';

const Root = styled('div')(({ theme, isActive }) => ({
  borderBottomLeftRadius: '16px',
  borderTopLeftRadius: '16px',
  width: '100%',
  height: '100%',
  backgroundColor: isActive ? '#F6F9F9' : theme.palette.porcelain['100Base'],
  padding: '1px',
}));

const Pattern = styled('div')(({ theme, isActive }) => ({
  width: '100%',
  height: '100%',
  borderBottomLeftRadius: '16px',
  borderTopLeftRadius: '16px',
  background: isActive
    ? `url(${diagonalLinesRight}), linear-gradient(179deg, #F6F9F9 0.67%, #F4F5F6 99.22%)`
    : `url(${diagonalLinesRight}), linear-gradient(179deg, #DDE1E3 0.67%, #E3E6E8 99.22%)`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ChamberLabel = styled('div')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '42px',
  color: theme.palette.porcelain[500],
  textShadow: '1px 1px 1px #FFFFFF, -1px -1px 0.3px rgba(0, 0, 0, 0.30)',
}));

const HandleLeftLarge = ({
  width = '50px',
  minWidth = '50px',
  height = '600px',
  label = 'A',
  isActive = false,
  ...props
}) => {
  return (
    <Root
      isActive={isActive}
      sx={{
        width: width,
        minWidth: minWidth,
        height: height,
      }}
      {...props}
    >
      <Pattern isActive={isActive}>
        <ChamberLabel>{label}</ChamberLabel>
      </Pattern>
    </Root>
  );
};

export default HandleLeftLarge;
